export const PageHeader = { height: '72px' };

export const Nav = { collapsedWidth: '72px', expandedWidth: ['232px', '232px', '248px', '264px', '264px'] };

export const ContainerDimensions = { maxWidth: '1440px', minHeight: '700' };

export const AgentSubmissionNav = { height: '40px' };

export const PagePadding = 6;

export const getContentHeightString = (...additionalSubs) => {
  const subs = [...additionalSubs, '0px'];
  return `calc(100vh - ${PageHeader.height} - ${subs.join(' - ')})`;
};
